import { QSCNode } from "./QSCNode";

export class QSCNodeList extends Array {
  constructor(subChartID) {
    super(subChartID);
    this.fSubChartID = subChartID;
  }
}
